<template>
    <a
        class="flex items-center justify-center w-full py-2.5 px-4 text-white font-bold text-lg bg-darkblue"
        href="/basket"
    >
        <icon-basket class="mr-2"/>
        Go to cart
    </a>
</template>
<script>
import IconBasket from "../Icons/IconBasket";

export default {
    name: 'GoToCartButton',
    components: { IconBasket },
}
</script>